<script>
import BuyerInput from 'sales-flow-ui/components/BuyerInput';

import emailLogoImg from '@/assets/images/home/email-logo.png';
import validator from './_home-validator';

export default {
  components: {
    BuyerInput,
  },
  data: () => ({
    email: null,
    emailLogoImg,
    validator,
    submitted: false,
  }),
  created() {
    validator.validate('email', this.email);
  },
  methods: {
    inputEmail(e) {
      this.email = e.target.value;

      validator.validate('email', this.email);

      console.log(validator)
    },
    clickSend(e) {
      if (!validator.hasError('email')) {
        console.log('call API')
      }

      this.submitted = true;
    },
  },
};
</script>

<template lang='pug'>
.mt-5.text-center.p-3.md_px-1.md_py-0.bg-brand-secondary-50.md_bg-transparent
  img.opacity-100.w-4.mx-auto(alt='viralstyle mail in envelope', :src='emailLogoImg')
  .text-4xl.font-bold.text-brand-secondary-900.mt-1 Get design inspiration and exclusive offers.
  .text-xl.text-brand-secondary-850.md_text-brand-secondary-700.mt-1.md_mt-0 Sign up for exclusives & 15% off on your first purchase!
  buyer-input.max-w-lg.mx-auto.mt-2(
    placeholder='Your email address',
    type='email-offers',
    :error-visible='submitted',
    :error='validator.firstError("email")'
    :value='email',
    @input='inputEmail',
    @search='clickSend'
  )
</template>

<style>
@import '~import/index';
</style>